import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import UIIcon from 'UIComponents/icon/UIIcon';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { ANNUAL, MONTHLY } from 'self-service-api/constants/Terms';
import SuiteNonMerchandiseIdMap from '../../../constants/merchCards/SuiteProductLevelIdentifiersMap';
import { useAppSelector } from '../../../reducers';
import { activeCurrencySelector } from '../../../selectors/CurrencySelectors';
import { hasPricingAndPurchasingSucceededSelector } from '../../../selectors/LoadingStateSelectors';
import { commonAvailableTermsSelector } from '../../../selectors/OfferSelectors';
import { calculatedPriceSelector } from '../../../selectors/PricingSelectors';
import { crmSuiteProductLevelSelector, productForSkuIdSelector, skuIdsContainOnlyCrmSuite } from '../../../selectors/ProductsSelectors';
import { getHoverInteractionEvent } from '../../../utils/event-tracking/interactions';
import { trackEvent } from '../../../utils/event-tracking/track-event';
import { MicroCopy } from './HighlightedPriceDisplay';
import PriceDisplay from './PriceDisplay';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const getAbbreviatedTerm = (payment, commitment) => {
  if (payment === ANNUAL && commitment === ANNUAL) return 'ACAP';
  if (payment === MONTHLY && commitment === ANNUAL) return 'ACMP';
  if (payment === MONTHLY && commitment === MONTHLY) return 'MCMP';
  return '';
};
const SSM0004PricingTermsSubtext = ({
  productConfigurations,
  queryParamTerm,
  selectedTermPricingInfo,
  showPricePerMonthPerSeat,
  location
}) => {
  const skuIds = productConfigurations.map(({
    skuId
  }) => skuId);
  const hasPricingAndPurchasingSucceeded = useAppSelector(hasPricingAndPurchasingSucceededSelector);
  const currencyCode = useAppSelector(activeCurrencySelector);
  const availableTerms = useAppSelector(state => {
    if (!hasPricingAndPurchasingSucceeded) return [];
    return commonAvailableTermsSelector(state, {
      skuIds
    });
  });
  const hasMultipleTerms = availableTerms.length > 1;
  const otherTermPricingInfo = useAppSelector(state => {
    if (!hasPricingAndPurchasingSucceeded || !hasMultipleTerms) return null;
    return calculatedPriceSelector(state, {
      productConfigurations,
      queryParamTerm: queryParamTerm === ANNUAL ? MONTHLY : ANNUAL
    });
  });
  const {
    payment,
    commitment
  } = selectedTermPricingInfo.offerInfo || {};
  const isUnbundledSuite = useAppSelector(state => {
    return skuIdsContainOnlyCrmSuite(state, {
      skuIds
    });
  });
  const suiteProductLevel = useAppSelector(state => {
    if (!isUnbundledSuite) return null;
    return crmSuiteProductLevelSelector(state, {
      skuIds
    });
  });
  const {
    apiName
  } = useAppSelector(state => productForSkuIdSelector(state, {
    skuId: selectedTermPricingInfo.skuId
  }));
  const dataTestId = suiteProductLevel && SuiteNonMerchandiseIdMap[suiteProductLevel] || apiName;
  const onTooltipHover = e => {
    if (e.target.value) {
      trackEvent(getHoverInteractionEvent({
        action: `hovered ${dataTestId} terms tooltip`,
        location
      }));
    }
  };
  if (!payment || !commitment) return null;
  return /*#__PURE__*/_jsxs(MicroCopy, {
    use: "help",
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      className: "m-right-1",
      message: `merchCards.pricing.ssm-0004.${getAbbreviatedTerm(payment, commitment)}`
    }), hasMultipleTerms && otherTermPricingInfo !== null && otherTermPricingInfo !== void 0 && otherTermPricingInfo.offerInfo ? /*#__PURE__*/_jsx(UITooltip, {
      "data-test-id": `${dataTestId}-terms-tooltip`,
      onOpenChange: onTooltipHover,
      placement: "right",
      title: /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: `merchCards.pricing.ssm-0004.toolTip.${showPricePerMonthPerSeat ? 'perMonthPerSeat' : 'perMonth'}.${getAbbreviatedTerm(otherTermPricingInfo.offerInfo.payment, otherTermPricingInfo.offerInfo.commitment)}`,
        options: {
          price: /*#__PURE__*/_jsx(PriceDisplay, {
            "data-test-id": `${dataTestId}-tooltip-price-per-month-per-seat`,
            currencyCode: currencyCode,
            price: otherTermPricingInfo.monthly.calculatedPrice
          })
        }
      }),
      children: /*#__PURE__*/_jsx(UIIcon, {
        name: "info",
        size: "xxs"
      })
    }) : null]
  });
};
export default SSM0004PricingTermsSubtext;